export enum CustomModelBuilderMode {
  view = "view",
  edit = "edit",
}
